import { render } from "./SinbadToken.vue?vue&type=template&id=5ccfa105"
const script = {}

import exportComponent from "/home/runner/work/sinbad-web3-demo/sinbad-web3-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__